import React, { useEffect, useState } from "react";
import api from "../lib/api";
import RegionTile from "../components/RegionTile";

export default function Scopri() {
  const [regions, setRegions] = useState([]);
  useEffect(() => { api.get("/regions").then(r => setRegions(r.data)); }, []);
  return (
    <div data-testid="scopri-page" className="container-xl py-12">
      <div className="text-xs uppercase tracking-[0.3em] text-[hsl(var(--primary))] font-semibold mb-2">Scopri</div>
      <h1 className="editorial-heading text-5xl md:text-6xl leading-none">Cucina per regione</h1>
      <p className="text-muted-foreground text-lg mt-3 max-w-2xl">Un viaggio gastronomico attraverso le venti regioni d'Italia. Scopri produttori, tradizioni e box selezionate.</p>
      <div className="mt-10 grid grid-cols-2 md:grid-cols-4 gap-4">
        {regions.map(r => <div key={r.slug} className="aspect-[4/5]"><RegionTile region={r} /></div>)}
      </div>
    </div>
  );
}
